import React from 'react';
import PageTitleNew from 'components/ui/PageTitleNew';

import { useNavigate, useParams } from 'react-router-dom';

import useReportTemplate from 'components/Common/ReportTemplates/Hooks/useReportTemplate';

import routes from 'app/routes';
import Form from '../Form/Index';

import NoData from '../../NoData';

import actions from '../../Actions';

export default function Edit() {
  const navigate = useNavigate();

  const { reportTemplateId } = useParams();

  const reportTemplate = useReportTemplate(reportTemplateId);

  if (reportTemplate === null) {
    return <NoData />;
  }

  const onSave = (values) => {
    actions.update(reportTemplateId, values, () => {
      navigate(routes.admin.report_templates.index);
    }, () => {
      alert('error');
    });
  };

  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="Edit Report" />

      <Form onSave={onSave} data={reportTemplate.attributes} />
    </div>

  );
}
